import React from "react";
import "../../css/ColorConstants.css";
import { FlexRow } from "./Containers";

export const TAG_COLORS = {
    GREEN_TAG: "green",
    YELLOW_TAG: "yellow",
    RED_TAG: "red",
    PURPLE_TAG: "purple",
    BLUE_TAG: "blue"
} as const;

export class Tag {
    title: string;
    color: string;

    constructor(title: string, color: string) {
        this.title = title;
        this.color = color;
    }
}

export const TAGS = {
    FREE: new Tag("Free", TAG_COLORS.GREEN_TAG),
    FREEMIUM: new Tag("Freemium", TAG_COLORS.YELLOW_TAG),
    PAID: new Tag("Paid", TAG_COLORS.RED_TAG),
    AUTH: new Tag("Auth", TAG_COLORS.PURPLE_TAG),
    NO_AUTH: new Tag("No Auth", TAG_COLORS.BLUE_TAG),
    BEGINNER: new Tag("Beginner", TAG_COLORS.GREEN_TAG),
    INTERMEDIATE: new Tag("Intermediate", TAG_COLORS.YELLOW_TAG),
    ADVANCED: new Tag("Advanced", TAG_COLORS.RED_TAG),
    ALL_LANGUAGES: new Tag("All Languages", TAG_COLORS.PURPLE_TAG),
    PYTHON: new Tag("Python", TAG_COLORS.BLUE_TAG),
    EASY: new Tag("Easy", TAG_COLORS.GREEN_TAG),
    MEDIUM: new Tag("Medium", TAG_COLORS.YELLOW_TAG),
    HARD: new Tag("Hard", TAG_COLORS.RED_TAG)
} as const;

interface BCTagListProps {
    tags: Tag[];
    className?: string;
}

export const BCTagList: React.FC<BCTagListProps> = ({ tags, className }) => {
    if (!tags || tags.length === 0) return null;
    return (
        <FlexRow gap={1} className={className}>
            {tags.map((tag, idx) => {
                return (
                    <FlexRow
                        key={idx}
                        borderRadius={0.5}
                        gap={0.5}
                        className={`tag-list-container tag-${tag.color}`}
                        pVertical={0.3}
                        pHorizontal={0.5}
                        justify={"center"}
                        align={"center"}>
                        {tag.title}
                    </FlexRow>
                );
            })}
        </FlexRow>
    );
};